import PropTypes from 'prop-types';
import $ from 'jquery';
import { makeStyles } from '@material-ui/styles';
//import { Sidebar, Sidebar1, Topbar, Footer } from './components';
import '../../content/assets/vendor/fontawesome/css/all.min.css';
import '../../content/assets/vendor/bootstrap/css/bootstrap.min.css';
import '../../content/assets/css/style-min.css';
import '../../content/assets/vendor/datetimepicker/jquery.datetimepicker.css';
// import "../../content/assets/vendor/fastselect-master/fastselect.min.css";
import '../../content/style.css';

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 64,
    height: '100%'
  },
  content: {
    height: '100%'
  }
}));

const Minimal = (props) => {
  const { children } = props;
  const classes = useStyles();
  // doi mau body trang chu
  if (
    window.location.pathname == '/' ||
    window.location.pathname == '/huong-dan'
  ) {
    $('body').addClass('classbody');
  }
  // end

  return (
    // <div className={classes.root}>
    <div>
      {/* <Topbar /> */}
      <main className={classes.content}>{children}</main>
    </div>
  );
};

Minimal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Minimal;
